<app-homepage-header pageName="{{'home-page-content.about_us' | translate}} "></app-homepage-header>

<section class="section-wrapper about-us-section about-us-section-lg">
  <div class="container">
    <div class="about-us-title-container">
      <span class="about-us-title mt-4">ScanMe</span>
      <span class="about-us-subtitle mt-3"
            [ngClass]="{'about-us-subtitle-am': currentLang === Language.HY}">{{ 'about-us-content.digital_handshake' | translate }}</span>
    </div>

    <main>
      <div class="flex-direction-row i-width-100 mt-100px">
        <div class="width-50">
          <ng-container [ngTemplateOutlet]="whoWeAre"></ng-container>
        </div>
        <div class="width-50">
          <img src="assets/about-us/first.png" alt="about us first" class="about-us-first-image">
        </div>
      </div>

      <div class="flex-direction-row i-width-100 mt-200px">
        <div class="width-50">
          @if (currentLang === Language.HY) {
            <img src="assets/about-us/second.png" alt="about us second" class="about-us-second-image">
          } @else {
            <img src="assets/about-us/second-en.png" alt="about us second" class="about-us-second-image">
          }
        </div>
        <div class="width-50 the-goal-lg">
          <ng-container [ngTemplateOutlet]="theGoal"></ng-container>
        </div>
      </div>
    </main>
  </div>
</section>

<section class="about-us-second-section about-us-section-lg">
  <div class="container">
<!--    todo-->
<!--    <main>-->
<!--      <div class="about-us-title-container">-->
<!--        <span class="about-us-primary-text">{{ 'about-us-content.our_team' | translate }}</span>-->
<!--      </div>-->

<!--      <div class="flex-direction-column mt-5 i-width-100">-->
<!--        @for (userGroup of users; track userGroup) {-->
<!--          <div class="flex-direction-row justify-content-around i-width-100 mt-5">-->
<!--            @for (user of userGroup; track user) {-->
<!--              <div class="about-us-card">-->
<!--                <img [src]="user.profilePicture" alt="about-us user">-->
<!--                <span class="about-card-title">{{ user.fullName }}</span>-->
<!--                <span class="about-card-subtitle">{{ user.jobTitle }}</span>-->
<!--              </div>-->
<!--            }-->
<!--          </div>-->
<!--        }-->
<!--      </div>-->
<!--    </main>-->
  </div>
</section>

<section class="section-wrapper-mb about-us-section-mb">
  <div class="about-us-title-container">
    <span class="about-us-title">ScanMe</span>
    <span class="about-us-subtitle mt-3">{{ 'about-us-content.digital_handshake' | translate }}</span>
  </div>

  <div class="i-width-100 mt-60px">
    <img src="assets/about-us/first-mb.png" alt="first mb" class="i-width-100">
    <div class="i-width-100 mt-40px">
      <ng-container [ngTemplateOutlet]="whoWeAre"></ng-container>
    </div>
  </div>

  <div class="i-width-100 mt-5">
    @if (currentLang === Language.HY) {
      <img src="assets/about-us/second-mb-hy.png" alt="second mb" class="i-width-100">
    } @else {
      <img src="assets/about-us/second-mb-en.png" alt="second mb" class="i-width-100">
    }
    <div class="i-width-100 mt-40px">
      <ng-container [ngTemplateOutlet]="theGoal"></ng-container>
    </div>
  </div>
<!--  todo-->
<!--  <main class="i-width-100 mt-100px justify-content-center flex-direction-column">-->
<!--    <div class="about-us-title-container mt-0">-->
<!--      <span class="about-us-primary-text">{{ 'about-us-content.our_team' | translate }}</span>-->
<!--    </div>-->

<!--    <div class="flex-direction-column mt-5 i-width-100">-->
<!--      @for (userGroup of users; track userGroup) {-->
<!--        @for (user of userGroup; track user) {-->
<!--          <div class="about-us-card mt-4">-->
<!--            <div class="user-picture-wrapper-mb">-->
<!--              <img [src]="user.profilePicture" alt="about-us user">-->
<!--            </div>-->
<!--            <span class="about-card-title">{{ user.fullName }}</span>-->
<!--            <span class="about-card-subtitle">{{ user.jobTitle }}</span>-->
<!--          </div>-->
<!--        }-->
<!--      }-->
<!--    </div>-->
<!--  </main>-->
</section>

<div class="mt-100px">
  <app-footer></app-footer>
</div>

<!-- TEMPLATES -->
<ng-template #whoWeAre>
  <span class="about-us-primary-text">{{ 'about-us-content.who_we_are' | translate }}</span>

  <div class="about-us-secondary-text flex-direction-column"
       [ngClass]="{'about-us-secondary-text-am': currentLang === Language.HY}">
    <span class="specific-span-class">
      {{ 'about-us-content.who_we_are_text' | translate }}
      <span
        class="about-us-bold-text">{{ 'about-us-content.eco-friendly' | translate }}</span>, {{ 'about-us-content.and' | translate }}
      <span
        class="about-us-bold-text"> {{ 'about-us-content.innovative' | translate }}</span> {{ 'about-us-content.text' | translate }}
    </span>
    <span>
      {{ 'about-us-content.who_we_are_text_1' | translate }}
    </span>
    <span>
      {{ 'about-us-content.who_we_are_text_2' | translate }}
    </span>
    <span>
     {{ 'about-us-content.who_we_are_text_3' | translate }}
    </span>
  </div>
</ng-template>

<ng-template #theGoal>
  <span class="about-us-primary-text">{{ 'about-us-content.the_goal' | translate }}</span>

  <div class="about-us-secondary-text" [ngClass]="{'about-us-secondary-text-am': currentLang === Language.HY}">
    <span class="specific-span-class">
      {{ 'about-us-content.the_goal_text' | translate }}
    </span>
    <span>
      {{ 'about-us-content.the_goal_text_1' | translate }}
    </span>
    <span>
     {{ 'about-us-content.the_goal_text_2' | translate }}
    </span>
    <span>
    {{ 'about-us-content.the_goal_text_3' | translate }}
    </span>
  </div>
</ng-template>
